import { useQuery } from '@tanstack/react-query';

import { bookingObjectsApi } from '@/shared/api/bookingObjects';
import { TDateRange } from '@/shared/types/app.types';

export const useObjectLoad = ({
	objectId,
	date,
	enabled,
}: {
	objectId: number | null;
	date: TDateRange | undefined;
	enabled: boolean | undefined;
}) => {
	const { data, isLoading } = useQuery({
		queryKey: ['objectLoad', date, objectId],
		queryFn: () =>
			objectId !== null && date ? bookingObjectsApi.getObjectLoad(objectId, date) : null,
		enabled: enabled,
	});

	return {
		objectLoad: data,
		isLoading: isLoading,
	};
};
